import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "food-label-manage" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","gap":"12px"} }
const _hoisted_3 = { style: {"margin-bottom":"16px","text-align":"right"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "pagination-container" }
const _hoisted_8 = {
  key: 1,
  style: {"text-align":"center","padding":"16px 0"}
}

import { ref, reactive, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { SearchOutlined, ReloadOutlined, ArrowLeftOutlined } from '@ant-design/icons-vue';
  import { message } from 'ant-design-vue';
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import dayjs, { type Dayjs } from 'dayjs';
  import { restoreSelectedShop, cacheSelectedShop } from '@/utils/selectedShop';
  import {
    fetchTagList,
    fetchTagDetail,
    addTag,
    updateTag,
    deleteTag,
    forbidTag,
    insertLanguageTranslation,
    updateLanguageTranslation,
    fetchLanguageTranslationList,
  } from '@/service/food';
  import { fetchShopList } from '@/service/base';
  import type { FoodTagDetailModel } from '@/model/food';

  type TagType = 1 | 2;

  
export default /*@__PURE__*/_defineComponent({
  __name: 'FoodLabelManageView',
  setup(__props) {

  const tagTypeOptions: Array<{ label: string; value: TagType }> = [
    { label: '分类标签', value: 1 },
    { label: '商品标签', value: 2 },
  ];

  // 表格列定义
  const columns = [
    {
      title: '标签ID',
      dataIndex: 'shopFoodLabelId',
      key: 'shopFoodLabelId',
      width: 100,
    },
    {
      title: '标签名称',
      dataIndex: 'labelName',
      key: 'labelName',
      width: 150,
    },
    {
      title: '标签类型',
      dataIndex: 'tagType',
      key: 'tagType',
      width: 120,
    },
    {
      title: '状态',
      dataIndex: 'labelStatus',
      key: 'labelStatus',
      width: 100,
    },
    {
      title: '店铺名称',
      dataIndex: 'shopName',
      key: 'shopName',
      width: 150,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 180,
    },
    {
      title: '操作',
      key: 'actions',
      width: 260,
      fixed: 'right',
    },
  ];

  // 响应式数据
  const loading = ref(false);
  const shopList = ref<any[]>([]);
  const tableData = ref<any[]>([]);
  const total = ref(0);
  const dateRange = ref<[Dayjs, Dayjs] | null>(null);
  const translationLanguageOptions = [
    { label: '英语', value: 'en' },
    { label: '法语', value: 'ja' },
  ];

  // 新增 / 编辑标签弹窗
  const labelModalVisible = ref(false);
  const labelModalLoading = ref(false);
  const isEdit = ref(false);
  const labelModalTitle = ref('新增标签');
  const labelForm = reactive({
    shopFoodLabelId: undefined as number | undefined,
    shopId: undefined as number | undefined,
    labelName: '',
    tagType: undefined as TagType | undefined,
    labelStatus: 0 as 0 | 1,
    sort: 1 as number,
    remark: '',
    translationLanguage: 'en',
    languageTranslationId: undefined as number | undefined,
    translationTagName: '',
  });

  // 标签详情弹窗
  const labelDetailVisible = ref(false);
  const labelDetailLoading = ref(false);
  const labelDetail = ref<FoodTagDetailModel | null>(null);

  // 查询参数
  const queryParams = reactive({
    createtimeBegin: '',
    createtimeEnd: '',
    pageNum: 1,
    pageSize: 20,
    data: {
      shopId: undefined as number | undefined,
      labelName: '',
      tagType: undefined as TagType | undefined,
      labelStatus: undefined as number | undefined,
    },
  });

  // 格式化日期时间
  const formatDateTime = (dateStr: string | Date | undefined) => {
    if (!dateStr) return '-';
    return dayjs(dateStr).format('YYYY-MM-DD HH:mm:ss');
  };

  const getTagTypeLabel = (tagType?: number) =>
    tagTypeOptions.find((option) => option.value === tagType)?.label || '-';

  // 根据店铺ID获取店铺名称（用于列表展示）
  const getShopName = (shopId?: number | string) => {
    if (!shopId) return '-';
    const idNum = Number(shopId);
    const shop = shopList.value.find((s) => s.shopId === idNum);
    return shop?.shopName || '-';
  };

  const getSelectedShop = (shopId?: number) => {
    if (!shopId) return undefined;
    return shopList.value.find((shop) => Number(shop.shopId) === Number(shopId));
  };

  const submitTagTranslation = async (tagId?: number) => {
    const translationTagName = labelForm.translationTagName.trim();
    if (!translationTagName) return;
    if (!tagId || !labelForm.shopId) {
      message.warning('标签保存成功，翻译缺少标签ID或店铺信息，未保存');
      return;
    }

    const shop = getSelectedShop(labelForm.shopId);
    if (!shop) {
      message.warning('标签保存成功，翻译缺少店铺公司信息，未保存');
      return;
    }

    const translationJson = JSON.stringify({ tagName: translationTagName });
    const resp = labelForm.languageTranslationId
      ? await updateLanguageTranslation({
          languageTranslationId: labelForm.languageTranslationId,
          translationJson,
          remark: labelForm.remark || '',
        })
      : await insertLanguageTranslation({
          companyId: Number(shop.companyId || 0),
          companyName: shop.companyName || '',
          language: labelForm.translationLanguage,
          type: 4,
          entityId: tagId,
          entityName: labelForm.labelName,
          translationJson,
          remark: labelForm.remark || '',
        });
    if (resp.code === 200) {
      message.success('标签翻译保存成功');
    } else {
      message.warning(resp.msg || '标签保存成功，翻译保存失败');
    }
  };

  const parseTranslationJson = (translationJson?: string) => {
    if (!translationJson) return undefined;
    try {
      return JSON.parse(translationJson) as { tagName?: string };
    } catch (error) {
      console.error('解析标签翻译失败:', error);
      return undefined;
    }
  };

  const loadTagTranslation = async (tagId?: number, shopId?: number) => {
    labelForm.translationTagName = '';
    labelForm.languageTranslationId = undefined;
    if (!tagId || !shopId) return;

    const shop = getSelectedShop(shopId);
    if (!shop) return;

    try {
      const resp = await fetchLanguageTranslationList({
        pageNum: 1,
        pageSize: 20,
        data: {
          companyId: Number(shop.companyId || 0),
          language: labelForm.translationLanguage,
          type: 4,
          status: 0,
          entityId: tagId,
        },
      });
      if (resp.code === 200) {
        const translation = resp.result.list?.[0];
        const translationData = parseTranslationJson(translation?.translationJson);
        labelForm.languageTranslationId = translation?.languageTranslationId;
        labelForm.translationTagName = translationData?.tagName || '';
      }
    } catch (error) {
      console.error('加载标签翻译失败:', error);
    }
  };

  const handleLabelTranslationLanguageChange = async () => {
    labelForm.translationTagName = '';
    labelForm.languageTranslationId = undefined;
    if (isEdit.value) {
      await loadTagTranslation(labelForm.shopFoodLabelId, labelForm.shopId);
    }
  };

  // 处理日期范围变化（开始时间传 00:00:00，结束时间传 23:59:59）
  const handleDateRangeChange = (dates: [Dayjs, Dayjs] | null) => {
    if (dates && dates[0] && dates[1]) {
      // 开始时间：当天 00:00:00
      queryParams.createtimeBegin = dates[0].startOf('day').format('YYYY-MM-DD HH:mm:ss');
      // 结束时间：当天 23:59:59
      queryParams.createtimeEnd = dates[1].endOf('day').format('YYYY-MM-DD HH:mm:ss');
    } else {
      queryParams.createtimeBegin = '';
      queryParams.createtimeEnd = '';
    }
  };

  // 加载店铺列表
  const loadShopList = async () => {
    try {
      const response = await fetchShopList({
        pageNum: 1,
        pageSize: 999,
        data: { shopStatus: 0 },
      });
      if (response.code === 200) {
        shopList.value = response.result.list || [];
        queryParams.data.shopId = restoreSelectedShop(shopList.value);
      }
    } catch (error) {
      console.error('加载店铺列表失败:', error);
      message.error('加载店铺列表失败');
    }
  };

  // 加载标签列表
  const loadLabelList = async () => {
    if (!queryParams.data.shopId) {
      tableData.value = [];
      total.value = 0;
      message.warning('请选择餐厅');
      return;
    }
    try {
      loading.value = true;

      // 构建查询参数，过滤掉空值
      const params: any = {
        pageNum: queryParams.pageNum,
        pageSize: queryParams.pageSize,
        data: {},
      };

      // 添加时间范围
      if (queryParams.createtimeBegin) {
        params.createtimeBegin = queryParams.createtimeBegin;
      }
      if (queryParams.createtimeEnd) {
        params.createtimeEnd = queryParams.createtimeEnd;
      }

      // 添加数据筛选条件（只添加有值的字段）
      if (queryParams.data.shopId !== undefined && queryParams.data.shopId !== null) {
        params.data.shopId = queryParams.data.shopId;
      }
      if (queryParams.data.labelName) {
        params.data.tagName = queryParams.data.labelName;
      }
      if (queryParams.data.tagType !== undefined && queryParams.data.tagType !== null) {
        params.data.tagType = queryParams.data.tagType;
      }
      if (queryParams.data.labelStatus !== undefined && queryParams.data.labelStatus !== null) {
        params.data.tagStatus = queryParams.data.labelStatus;
      }

      const response = await fetchTagList(params);
      if (response.code === 200) {
        // 将 API 返回的字段映射为界面使用的字段
        const list = (response.result.list || []).map((item: any) => ({
          ...item,
          shopFoodLabelId: item.shopFoodTagId,
          labelName: item.tagName,
          tagType: item.tagType,
          labelStatus: item.tagStatus,
        }));
        tableData.value = list;
        total.value = response.result.total || 0;
      } else {
        message.error(response.msg || '查询失败');
        tableData.value = [];
        total.value = 0;
      }
    } catch (error) {
      console.error('加载标签列表失败:', error);
      message.error('加载标签列表失败，请稍后重试');
      tableData.value = [];
      total.value = 0;
    } finally {
      loading.value = false;
    }
  };

  // 查询
  const handleSearch = () => {
    queryParams.pageNum = 1;
    loadLabelList();
  };

  // 打开新增标签弹窗
  const openAddLabelModal = () => {
    isEdit.value = false;
    labelModalTitle.value = '新增标签';
    labelForm.shopFoodLabelId = undefined;
    labelForm.shopId = queryParams.data.shopId;
    labelForm.labelName = '';
    labelForm.tagType = undefined;
    labelForm.labelStatus = 0;
    labelForm.sort = 1;
    labelForm.remark = '';
    labelForm.translationLanguage = 'en';
    labelForm.languageTranslationId = undefined;
    labelForm.translationTagName = '';
    labelModalVisible.value = true;
  };

  // 打开编辑标签弹窗
  const handleEditLabel = async (record: any) => {
    isEdit.value = true;
    labelModalTitle.value = '编辑标签';
    labelModalLoading.value = true;
    try {
      const resp = await fetchTagDetail({
        shopFoodTagId: record.shopFoodLabelId,
      });
      if (resp.code === 200 && resp.result) {
        const data = resp.result;
        labelForm.shopFoodLabelId = data.shopFoodTagId;
        labelForm.shopId = data.shopId as number | undefined;
        labelForm.labelName = data.tagName || '';
        labelForm.tagType = data.tagType as TagType | undefined;
        labelForm.labelStatus =
          (data.tagStatus as 0 | 1 | undefined) !== undefined ? (data.tagStatus as 0 | 1) : 0;
        labelForm.sort = data.sort ?? 1;
        labelForm.remark = data.remark || '';
        labelForm.translationLanguage = 'en';
        labelForm.languageTranslationId = undefined;
        labelForm.translationTagName = '';
        await loadTagTranslation(data.shopFoodTagId, data.shopId);
        labelModalVisible.value = true;
      } else {
        message.error(resp.msg || '获取标签详情失败');
      }
    } catch (error) {
      console.error('获取标签详情异常:', error);
      message.error('获取标签详情异常，请稍后重试');
    } finally {
      labelModalLoading.value = false;
    }
  };

  // 保存标签（新增 / 编辑）
  const handleLabelModalOk = async () => {
    // 新增时必须选择店铺
    if (!isEdit.value && !labelForm.shopId) {
      message.warning('请选择店铺');
      return;
    }
    if (!labelForm.labelName) {
      message.warning('请输入标签名称');
      return;
    }
    if (!labelForm.tagType) {
      message.warning('请选择标签类型');
      return;
    }
    if (labelForm.sort < 0) {
      message.warning('排序值不能为负数');
      return;
    }

    labelModalLoading.value = true;
    try {
      if (isEdit.value) {
        // 编辑
        const payload = {
          shopFoodTagId: labelForm.shopFoodLabelId,
          tagName: labelForm.labelName,
          tagType: labelForm.tagType,
          sort: labelForm.sort,
          remark: labelForm.remark,
        };
        const resp = await updateTag(payload);
        if (resp.code === 200) {
          message.success('编辑标签成功');
          await submitTagTranslation(labelForm.shopFoodLabelId);
          labelModalVisible.value = false;
          await loadLabelList();
        } else {
          message.error(resp.msg || '编辑标签失败');
        }
      } else {
        // 新增
        const payload = {
          shopId: labelForm.shopId,
          tagName: labelForm.labelName,
          tagType: labelForm.tagType,
          tagStatus: labelForm.labelStatus ?? 0,
          sort: labelForm.sort,
          remark: labelForm.remark,
        };
        const resp = await addTag(payload);
        if (resp.code === 200) {
          message.success('新增标签成功');
          await submitTagTranslation(Number(resp.result || 0));
          labelModalVisible.value = false;
          await loadLabelList();
        } else {
          message.error(resp.msg || '新增标签失败');
        }
      }
    } catch (error) {
      console.error('保存标签异常:', error);
      message.error('保存标签异常，请稍后重试');
    } finally {
      labelModalLoading.value = false;
    }
  };

  // 取消标签弹窗
  const handleLabelModalCancel = () => {
    labelModalVisible.value = false;
    labelForm.translationLanguage = 'en';
    labelForm.languageTranslationId = undefined;
    labelForm.translationTagName = '';
  };

  // 禁用 / 启用 标签
  const handleToggleLabelStatus = async (record: any) => {
    const targetStatus = record.labelStatus === 0 ? 1 : 0;
    try {
      const resp = await forbidTag({
        shopFoodTagId: record.shopFoodLabelId,
        tagStatus: targetStatus,
      });
      if (resp.code === 200) {
        message.success(targetStatus === 1 ? '标签已禁用' : '标签已启用');
        await loadLabelList();
      } else {
        message.error(resp.msg || '更新标签状态失败');
      }
    } catch (error) {
      console.error('更新标签状态异常:', error);
      message.error('更新标签状态异常，请稍后重试');
    }
  };

  // 删除标签
  const handleDeleteLabel = async (record: any) => {
    try {
      const resp = await deleteTag({
        shopFoodTagId: record.shopFoodLabelId,
      });
      if (resp.code === 200) {
        message.success('删除标签成功');
        await loadLabelList();
      } else {
        message.error(resp.msg || '删除标签失败');
      }
    } catch (error) {
      console.error('删除标签异常:', error);
      message.error('删除标签异常，请稍后重试');
    }
  };

  // 查看标签详情
  const handleViewLabelDetail = async (record: any) => {
    labelDetailVisible.value = true;
    labelDetailLoading.value = true;
    labelDetail.value = null;
    try {
      const resp = await fetchTagDetail({
        shopFoodTagId: record.shopFoodLabelId,
      });
      if (resp.code === 200 && resp.result) {
        labelDetail.value = resp.result;
      } else {
        message.error(resp.msg || '获取标签详情失败');
      }
    } catch (error) {
      console.error('获取标签详情异常:', error);
      message.error('获取标签详情异常，请稍后重试');
    } finally {
      labelDetailLoading.value = false;
    }
  };

  // 重置
  const handleReset = () => {
    queryParams.pageNum = 1;
    queryParams.pageSize = 20;
    queryParams.createtimeBegin = '';
    queryParams.createtimeEnd = '';
    queryParams.data.labelName = '';
    queryParams.data.tagType = undefined;
    queryParams.data.labelStatus = undefined;
    dateRange.value = null;
    loadLabelList();
  };

  // 分页变化
  const handlePageChange = (page: number) => {
    queryParams.pageNum = page;
    loadLabelList();
  };

  // 每页条数变化
  const handlePageSizeChange = (current: number, size: number) => {
    queryParams.pageNum = 1;
    queryParams.pageSize = size;
    loadLabelList();
  };

  // 路由
  const router = useRouter();

  // 返回上一页
  const goBack = () => {
    router.back();
  };

  // 初始化
  onMounted(async () => {
    await loadShopList();
    await loadLabelList();
  });

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_config_provider, { locale: _unref(zhCN) }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { bordered: false }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_button, {
                  type: "text",
                  style: {"padding":"0"},
                  onClick: goBack
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(ArrowLeftOutlined))
                  ]),
                  _: 1
                }),
                _cache[17] || (_cache[17] = _createElementVNode("span", { style: {"font-size":"18px","font-weight":"600"} }, "菜品标签管理", -1))
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: queryParams,
                layout: "inline",
                class: "search-form",
                onSubmit: [
                  handleSearch,
                  _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "店铺" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryParams.data.shopId,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.data.shopId) = $event)),
                        disabled: "",
                        placeholder: "请选择店铺",
                        style: {"width":"200px"},
                        onChange: _unref(cacheSelectedShop)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: shop.shopId,
                              value: shop.shopId
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(shop.shopName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "标签名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryParams.data.labelName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.data.labelName) = $event)),
                        placeholder: "请输入标签名称",
                        "allow-clear": "",
                        style: {"width":"200px"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "标签类型" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryParams.data.tagType,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.data.tagType) = $event)),
                        placeholder: "请选择标签类型",
                        "allow-clear": "",
                        style: {"width":"140px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tagTypeOptions, (option) => {
                            return _createVNode(_component_a_select_option, {
                              key: option.value,
                              value: option.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(option.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryParams.data.labelStatus,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.data.labelStatus) = $event)),
                        placeholder: "请选择状态",
                        "allow-clear": "",
                        style: {"width":"120px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: 0 }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode("正常", -1)
                            ])),
                            _: 1,
                            __: [18]
                          }),
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode("禁用", -1)
                            ])),
                            _: 1,
                            __: [19]
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        value: dateRange.value,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dateRange).value = $event)),
                        format: "YYYY-MM-DD",
                        style: {"width":"240px"},
                        onChange: handleDateRangeChange
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit",
                        loading: loading.value
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(SearchOutlined))
                        ]),
                        default: _withCtx(() => [
                          _cache[20] || (_cache[20] = _createTextVNode(" 查询 ", -1))
                        ]),
                        _: 1,
                        __: [20]
                      }, 8, ["loading"]),
                      _createVNode(_component_a_button, {
                        style: {"margin-left":"8px"},
                        onClick: handleReset
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(ReloadOutlined))
                        ]),
                        default: _withCtx(() => [
                          _cache[21] || (_cache[21] = _createTextVNode(" 重置 ", -1))
                        ]),
                        _: 1,
                        __: [21]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: openAddLabelModal
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode(" 新增标签 ", -1)
                  ])),
                  _: 1,
                  __: [22]
                })
              ]),
              _createVNode(_component_a_table, {
                columns: columns,
                "data-source": tableData.value,
                loading: loading.value,
                pagination: false,
                "row-key": "shopFoodLabelId",
                scroll: { x: 'max-content' }
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'labelStatus')
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: record.labelStatus === 0 ? 'green' : 'red'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.labelStatus === 0 ? '正常' : '禁用'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"]))
                    : (column.key === 'tagType')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(getTagTypeLabel(record.tagType)), 1))
                      : (column.key === 'shopName')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(getShopName(record.shopId)), 1))
                        : (column.key === 'createTime')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(formatDateTime(record.createTime)), 1))
                          : (column.key === 'actions')
                            ? (_openBlock(), _createBlock(_component_a_space, { key: 4 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "link",
                                    size: "small",
                                    onClick: ($event: any) => (handleEditLabel(record))
                                  }, {
                                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                                      _createTextVNode(" 编辑 ", -1)
                                    ])),
                                    _: 2,
                                    __: [23]
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_a_popconfirm, {
                                    title: record.labelStatus === 0 ? '确认禁用该标签？' : '确认启用该标签？',
                                    "ok-text": "是",
                                    "cancel-text": "否",
                                    onConfirm: ($event: any) => (handleToggleLabelStatus(record))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "link",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(record.labelStatus === 0 ? '禁用' : '启用'), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["title", "onConfirm"]),
                                  _createVNode(_component_a_popconfirm, {
                                    title: "确认删除该标签？",
                                    "ok-text": "是",
                                    "cancel-text": "否",
                                    onConfirm: ($event: any) => (handleDeleteLabel(record))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "link",
                                        danger: "",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                                          _createTextVNode("删除", -1)
                                        ])),
                                        _: 1,
                                        __: [24]
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data-source", "loading"]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_pagination, {
                  current: queryParams.pageNum,
                  "onUpdate:current": _cache[6] || (_cache[6] = ($event: any) => ((queryParams.pageNum) = $event)),
                  "page-size": queryParams.pageSize,
                  "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((queryParams.pageSize) = $event)),
                  total: total.value,
                  "show-total": (total) => `共 ${total} 条`,
                  "show-size-changer": true,
                  "page-size-options": ['10', '20', '50', '100'],
                  onChange: handlePageChange,
                  onShowSizeChange: handlePageSizeChange
                }, null, 8, ["current", "page-size", "total", "show-total"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["locale"])
    ]),
    _createVNode(_component_a_modal, {
      open: labelModalVisible.value,
      "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ((labelModalVisible).value = $event)),
      title: labelModalTitle.value,
      "confirm-loading": labelModalLoading.value,
      "ok-text": "保存",
      "cancel-text": "取消",
      width: 640,
      "wrap-class-name": "label-modal",
      onOk: handleLabelModalOk,
      onCancel: handleLabelModalCancel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "店铺",
              required: ""
            }, {
              default: _withCtx(() => [
                (!isEdit.value)
                  ? (_openBlock(), _createBlock(_component_a_select, {
                      key: 0,
                      value: labelForm.shopId,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((labelForm.shopId) = $event)),
                      disabled: "",
                      placeholder: "请选择店铺"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: shop.shopId,
                            value: shop.shopId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(shop.shopName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"]))
                  : (_openBlock(), _createBlock(_component_a_input, {
                      key: 1,
                      value: getShopName(labelForm.shopId),
                      disabled: "",
                      placeholder: "店铺"
                    }, null, 8, ["value"]))
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "标签名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: labelForm.labelName,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((labelForm.labelName) = $event)),
                  placeholder: "请输入标签名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "标签类型",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: labelForm.tagType,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((labelForm.tagType) = $event)),
                  placeholder: "请选择标签类型",
                  "allow-clear": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tagTypeOptions, (option) => {
                      return _createVNode(_component_a_select_option, {
                        key: option.value,
                        value: option.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(option.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "翻译语言" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: labelForm.translationLanguage,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((labelForm.translationLanguage) = $event)),
                  placeholder: "请选择翻译语言",
                  onChange: handleLabelTranslationLanguageChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(translationLanguageOptions, (language) => {
                      return _createVNode(_component_a_select_option, {
                        key: language.value,
                        value: language.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(language.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "标签翻译名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: labelForm.translationTagName,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((labelForm.translationTagName) = $event)),
                  placeholder: "请输入标签翻译名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "排序" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: labelForm.sort,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((labelForm.sort) = $event)),
                  min: 0,
                  style: {"width":"100%"},
                  placeholder: "请输入排序（数字，越小越靠前）"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: labelForm.remark,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((labelForm.remark) = $event)),
                  rows: 3,
                  maxlength: 200,
                  "show-count": "",
                  placeholder: "请输入备注"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "title", "confirm-loading"]),
    _createVNode(_component_a_modal, {
      open: labelDetailVisible.value,
      "onUpdate:open": _cache[16] || (_cache[16] = ($event: any) => ((labelDetailVisible).value = $event)),
      title: "标签详情",
      footer: null,
      width: 520
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_spin, { spinning: labelDetailLoading.value }, {
          default: _withCtx(() => [
            (labelDetail.value)
              ? (_openBlock(), _createBlock(_component_a_descriptions, {
                  key: 0,
                  bordered: "",
                  column: "1",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_descriptions_item, { label: "标签ID" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(labelDetail.value.shopFoodTagId), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "标签名称" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(labelDetail.value.tagName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "标签类型" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getTagTypeLabel(labelDetail.value.tagType)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tag, {
                          color: labelDetail.value.tagStatus === 0 ? 'green' : 'red'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(labelDetail.value.tagStatus === 0 ? '正常' : '禁用'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "排序" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(labelDetail.value.sort), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "备注" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(labelDetail.value.remark || '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "创建时间" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formatDateTime(labelDetail.value.createTime)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "修改时间" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formatDateTime(labelDetail.value.modifyTime)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, "暂无数据"))
          ]),
          _: 1
        }, 8, ["spinning"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})